// React
import React, { useEffect, useState } from 'react';
import { ButtonGroup, Chip, IconButton, } from '@material-ui/core';
import { Description, RestorePage, NoteAdd } from '@material-ui/icons';
// componentes
import Title from 'components/TitleWithIcon';
import Table from 'components/Table';
import CustomToolTip from 'components/tooltip';
import { useStyles } from "./style";
import ApiServices from 'services/ApiServices';
import { showMessagePersonalizedPosition } from 'services/SweetAlert';
import DialogLoadingMessage from 'components/LoadingMessage/index'
import ComponenteMostrarObservacion from './MostrarObservacion'
import ComponenteMostrarInformeGeneradoModal from 'pages/CierrePadron/MostrarInformeGeneradoModal'
import ComponenteGenerarInforme from './ComponenteGenerarInforme'
import ComponenteDeEstadisticas from './MostrarEstadisticas'

let codigoDepartamento =''
export default function ComponenteInformeDeCierrePadronDelegados (props) {
    const classes = useStyles();
    const [showTable, setShowTable] = useState(false);
    const [showObservation, setShowObservation] = useState({show: false, observation: ''});
    const [loadingMessage, setLoadingMessage] = useState({open: false, title: ''});
    const header = [
        { title: 'Departamento', field: 'departamentoCierre.name'},
        { title: 'Municipio', field: 'municipioCierre.name'},
        { title: 'Nombre', field: 'usuarioAsignado.nombre'},
        { title: 'Usuario asignado', field: 'usuarioAsignado.codUsuario'},
        { title: 'Descripcion', field: 'usuarioAsignado.descripcion'},
        { title: 'Usuario genero', field: 'usuario_genero'},
        { title: 'Fecha', field: 'fechaString'},
        { title: 'CUI Final', field: 'cui_final'},
        { title: 'observaciones', 
            render: (rowData) => (
                <div>
                    {(rowData.observaciones) ? (
                        <IconButton  size="small" color="primary"
                            onClick={() => {
                                funcionAbrirModalParaVerObservacion(rowData.observaciones)
                            }}
                        >
                            <img alt="comments" style={{ height: 40, width: 40 }} src="/assets/comments.svg" />
                        </IconButton>
                    ) : ""}
                </div>
        )
        },
        { title: 'Estado', field: '',
            render: rowData=><div>
                {
                    (rowData.estado === 1) ?
                        <Chip label="Generado" variant="outlined" className={classes.success}/>
                    : (rowData.estado === 0) ? <Chip label="Pendiente" variant="outlined" className={classes.error}/>
                    : <Chip label="Pendiente" variant="outlined" className={classes.error}/>
                }
            </div>
        },
        { title: 'Acción',
            render: rowData=><div>
                <ButtonGroup color="primary" aria-label="outlined primary button group">
                    {
                        (rowData.estado === 1) ?
                        <CustomToolTip title="Ver informe" handleFunction={() => funcionAbrirComponenteParaVerInformeGeneradoPorDeptoAndMuni(rowData)}><Description/></CustomToolTip>
                        : <CustomToolTip title="Generar Informe" handleFunction={() => funcionAbrirComponenteParaGenerarInformeDeUnOperador(rowData)}><NoteAdd style={{color: 'green'}}/></CustomToolTip>
                    }
                </ButtonGroup>
            </div>
        },
    ];
    const [viewReport, setViewReport] = useState({show: false, base64: '', data: {depto:'', muni:''}});
    const [showModalToGenerateReport, setShowModalToGenerateReport] = useState({open: false, data:''});
    
        const showList = async (getDepartamento) =>{
            if(codigoDepartamento || getDepartamento){
                setShowTable(false);
                setLoadingMessage({open: true, title: 'Obteniendo información ...'})
                try{
                    const hasPermission = await ApiServices.userSecurity.hasPermission('generarInformeCierre','list');    
                    if (hasPermission.error){
                        showMessagePersonalizedPosition('warning', hasPermission.error?.message)
                    }else{
                        ApiServices.generarInformeCierre.initSearchCriteria.clear();
                        ApiServices.generarInformeCierre.initSearchCriteria.setOperator("and");
                        ApiServices.generarInformeCierre.initSearchCriteria.addEquals("departamento", codigoDepartamento || getDepartamento);
                        ApiServices.generarInformeCierre.initOrderCriteria.clear();
                        setShowTable(true);
                    }
                }catch(exception){
                    showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de Nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.")
                }
                setLoadingMessage({open: false, title: ''})
            }else{
                showMessagePersonalizedPosition('warning', '¡Advertencia!', "Código de departamento está vacío, no se pudo obtener el listado de la tabla.")
            }
        }

    //funciones para obtener el informe que ya esta generado y mostrarlo
        const funcionAbrirComponenteParaVerInformeGeneradoPorDeptoAndMuni = async (data) =>{
            setLoadingMessage({open: true, title: 'Consultando informe ...'})
            setViewReport({show: false, base64:'', data: { depto: '', muni: ''}})
            let saveData = {
                coddep: data?.departamentoCierre?.id?.coddep,
                codmun: data?.municipioCierre?.id?.codmun,
            }
            try{
                const response = await ApiServices.generarInformeCierre.obtenerBase64(saveData);    
                if (response.error){
                    showMessagePersonalizedPosition('warning', '¡Advertencia!', response?.error?.message)
                }else{
                    setViewReport({show: true, base64: response.data, data: { depto: data?.departamentoCierre?.name, muni: data?.municipioCierre?.name}})
                    showMessagePersonalizedPosition('success','¡BIEN!', 'Informe obtenido correctamente.')
                }
            }catch(exception){
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de Nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.")
            }
            setLoadingMessage({open: false, title: ''})
        }
        const funcionCerrarComponenteParaVerInformeGeneradoPorDeptoAndMuni = () =>{
            setViewReport({show: false, base64:'', data: { depto: '', muni: ''}})
        }

    //funciones para mostrar la observacion
        const funcionAbrirModalParaVerObservacion = (observacion) => {
            setShowObservation({show: true, observation: observacion});
        }
        const funcionCerrarModalParaVerObservacion = () => {
            setShowObservation({show: false, observation: ''});
        }
    //funciones para mostrar el formulario para generar un informe de un operador
        const funcionAbrirComponenteParaGenerarInformeDeUnOperador = (data) => {
            setShowModalToGenerateReport({open: true, data: {depto: {id: data?.departamentoCierre?.id?.coddep, name: data.departamentoCierre?.name}, muni: {id: data?.municipioCierre?.id?.codmun, name: data.municipioCierre?.name}, general: data}});
        }
        const funcionCerrarComponenteParaGenerarInformeDeUnOperador = () => {
            setShowModalToGenerateReport({open: false, data:''});
        }
    // funciones para las estadisticas
        const [datosEstadistica, setDatosEstadistica] = useState({generados: 0, pendientes: 0});
        const FuncionObtenerEstadisticasDelegacion = async (getDepartamento) => {
            if(codigoDepartamento || getDepartamento){
                setDatosEstadistica({generados: 0, pendientes: 0})
                setLoadingMessage({loading: true, title:'Actualizando datos de informes ...'})                
                let saveData = {
                    coddep: codigoDepartamento || getDepartamento,
                    tipo: 1,
                };
                try {
                    let response = await ApiServices.generarInformeCierre.estadisticas(saveData)
                    if(response.error!==null){
                        showMessagePersonalizedPosition('error','¡Advertencia!', response.error,'center')
                    }
                    else{
                        setDatosEstadistica({generados: response.data[0].generados, pendientes: response.data[1].generados})
                    }
                } catch (exception) {
                    showMessagePersonalizedPosition('error', '¡Advertencia! ',"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
                }  
                setLoadingMessage({loading: false, title:''})
            }else{
                showMessagePersonalizedPosition('warning', '¡Advertencia!', "Código de departamento está vacío no se pudo obtener las estadísticas")
            }
        };

    // funcion para obtener los datos del operador
        const FuncionObtenerDeptoAndMunUsuario = async () =>{
            setLoadingMessage({loading: true, title:'Obteniendo datos ...'})
            try{
                const response = await ApiServices.generarInformeCierre.getDeptoMpioUsuarioInforme();
                if(response.error){
                    showMessagePersonalizedPosition('warning','¡Advertencia!', response.error?.message,'center')
                }else {  
                    showMessagePersonalizedPosition('success','¡BIEN!', 'Datos obtenidos correctamente.','center')
                    codigoDepartamento = response.data?.codDep
                    showList(response.data?.codDep)
                    FuncionObtenerEstadisticasDelegacion(response.data?.codDep)
                } 
            }catch(exception){
                showMessagePersonalizedPosition('error', '¡Advertencia! ',"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
            }     
            setLoadingMessage({loading: false, title:''})        
        }  

        useEffect(()=>{
            FuncionObtenerDeptoAndMunUsuario()
            // FuncionObtenerEstadisticasDelegacion()
        },[]);

        const FuncionActualizarTablaYEstadisticas = () =>{
            FuncionObtenerEstadisticasDelegacion()            
            showList()            
        }
    return (
        <div className={classes.contenedorPrincipal}>
            {
                loadingMessage.open && (
                    <DialogLoadingMessage open={loadingMessage.open} title={loadingMessage.title}/>
                )
            }
            <Title title={'Informe de Cierre Delegados'} icon={"/assets/Reporte.png"}/><br/>
            <ComponenteDeEstadisticas datosEstadistica={datosEstadistica}/>
            { (showTable) && (
                <Table  
                        service={ApiServices.generarInformeCierre}
                        header = {header}
                        showFilterGeneral={false}
                        showToolbar={false}
                        showToolbarPerzonalized={true}
                        ActualizarTabla={FuncionActualizarTablaYEstadisticas}
                        showToolbarTitle={'Listado de sub-delegaciones'}
                />
            )}
            {
                (showObservation.show) && (
                    <ComponenteMostrarObservacion open={showObservation.show} observacion={showObservation.observation} closeModal={funcionCerrarModalParaVerObservacion}/>                    
                )
            }
            {
                (viewReport.show) && (
                    <ComponenteMostrarInformeGeneradoModal 
                        open={viewReport.show}
                        base64={viewReport.base64}
                        fullScreen={true}
                        closeModal={funcionCerrarComponenteParaVerInformeGeneradoPorDeptoAndMuni}
                        iconToolbar={<Description />}
                        titleToolbar={'Informe de: '+viewReport.data.depto+' - '+viewReport.data.muni}
                    />                    
                )
            }
            {
                (showModalToGenerateReport.open) && (
                    <ComponenteGenerarInforme
                        open={showModalToGenerateReport.open}
                        data={showModalToGenerateReport.data}
                        fullScreen={true}
                        closeModal={funcionCerrarComponenteParaGenerarInformeDeUnOperador}
                        iconToolbar={<NoteAdd />}
                        titleToolbar={'Generar informe'}
                        actualizarTabla={FuncionObtenerDeptoAndMunUsuario}
                    />                    
                )
            }
            <br/><br/><br/><br/>
        </div>
    )}